// extracted by mini-css-extract-plugin
export default {"container":"SlickSlider__container___kRYKE"};